import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './TableSpinner.translations.json';
import { Spinner } from '../../components';

const { addTranslations, useTranslation } = i18nNsFactory('table-spinner');
addTranslations(translations);

export const TableSpinner = () => {
  const { t } = useTranslation();

  return <Spinner overlay delay={200} message={t('table-loading')} />;
};
